'use strict';

import React from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import Strings from '../../../../../app/shared/Strings';
const AssetUtil = require('../../../util/asset');

const propTypes = {
    onClickBrandLogo: PropTypes.func,
    logoLinkDisable: PropTypes.bool,
    useMinLogo: PropTypes.bool,
    customLogo: PropTypes.object,
};

const defaultProps = {
    onClickBrandLogo: () => {},
    logoLinkDisable: false,
    useMinLogo: false,
    customLogo: null,
}


function BrandLogo(props) {
    let customBrandText;
    let customImgSrc;
    let customAltText;
    
    if (props.customLogo) {
        customAltText = props.customLogo.alt || ' ';
        customBrandText = props.customLogo.name || ' ';
        customImgSrc = AssetUtil.resolveAssetPath(props.customLogo.src);
    }

    const brandText = (<span className="brand-name">{customBrandText || Strings['en'].common.MUZZY_LANE}</span>)
    const minLogo = (
        <span>
            <img src={customImgSrc || `${GlobalConfig.StaticUrl}/img/logo-top-min.svg`} alt={customAltText || Strings['en'].common.MUZZY_LANE}/>
        </span>
    );

    //even when props.useMinLogo = false, we use min logo for xs resolution
    const logoImg = props.useMinLogo ? minLogo :
    (
        <span>
            <span className="d-none d-sm-none d-md-inline">
                <img src={customImgSrc || `${GlobalConfig.StaticUrl}/img/logo-top-no-words.svg`} alt={customAltText || Strings['en'].common.MUZZY_LANE_AUTHOR}/>
                {brandText}
            </span>
            <span className="d-inline-block d-md-none">
                {minLogo}
            </span>
        </span>
    );
    
    if (props.logoLinkDisable) {
        return (
            <div className='brand-logo db3BrandLogo'>
                {logoImg}
            </div>
        );
    }
    
    return (
        <button className='brand-logo db3BrandLogo' onClick={props.onClick}>
            {logoImg}
        </button>
    );
}

BrandLogo.propTypes = propTypes;
BrandLogo.defaultProps = defaultProps;

export default BrandLogo;